<template>
    <div class="case-docket">
        <!-- Page Header -->
        <div class="page-head">
            <h2 class="title">Case Docket</h2>
        </div>
        <div>
            <v-tabs v-model="tabselect" color="#55638E" class="custom-tabs" style="border-bottom: 1px solid #E0E0E0;">
                <v-tab>Internal Work</v-tab>
                <v-tab>Internal Timeline</v-tab>
            </v-tabs>
        </div>
        <v-form ref="form" v-model="formValid">
            <v-card outlined class="docket-panel pa-6 mt-5" v-if="tabselect == 0">

                <!-- ============ SECTION A: ข้อมูลคดี ============ -->
                <div class="sec">
                    <div class="sec-label">A · ข้อมูลคดี (Case Identification)</div>

                    <v-row>
                        <v-col cols="12" md="6">
                            <div class="field-label">
                                รหัสคดีภายใน <span class="hint">(auto)</span>
                            </div>
                            <v-text-field v-model="form.internalCaseNo" disabled outlined dense hide-details="auto"
                                background-color="#f2f2f2" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <div class="field-label">เลขคดีดำ (Black No.)</div>
                            <v-text-field v-model="form.blackNo" placeholder="เช่น พ.1234/69" outlined dense
                                hide-details="auto" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <div class="field-label">
                                ลูกค้า (Client) <span class="req">*</span>
                                <v-tooltip top max-width="260">
                                    <template #activator="{ on, attrs }">
                                        <span class="info-tag" v-bind="attrs" v-on="on">i</span>
                                    </template>
                                    <span>แนะนำเพิ่ม: ระบุว่าเราเป็นทนายให้ฝ่ายใด ใช้ผูกกับ Sales Order
                                        และการวางบิล</span>
                                </v-tooltip>

                            </div>
                            <v-autocomplete v-model="form.clientId" :items="clientList" item-text="name" item-value="id"
                                placeholder="เลือกลูกค้า / องค์กร" :rules="[rules.required]" outlined dense
                                hide-details="auto" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <div class="field-label">เลขคดีแดง (Red No.)</div>
                            <v-text-field v-model="form.redNo" placeholder="ออกเมื่อศาลรับฟ้อง" outlined dense
                                hide-details="auto" />
                        </v-col>

                        <v-col cols="12">
                            <div class="field-label">ข้อหา / ฐานความผิด</div>
                            <v-text-field v-model="form.charge" placeholder="เช่น ผิดสัญญาซื้อขาย / ฉ้อโกง" outlined
                                dense hide-details="auto" />
                        </v-col>
                    </v-row>

                    <v-row class="mt-1">
                        <v-col cols="12" md="4">
                            <div class="field-label">ศาล</div>
                            <v-select v-model="form.court" :items="courtList" item-text="name" item-value="id"
                                placeholder="— เลือก —" outlined dense hide-details="auto" />
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="field-label">แผนก</div>
                            <v-select v-model="form.department" :items="departmentList" item-text="name" item-value="id"
                                placeholder="— เลือก —" outlined dense hide-details="auto" />
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="field-label">ประเภทคดี</div>
                            <v-select v-model="form.caseType" :items="caseTypeList" item-text="name" item-value="id"
                                placeholder="— เลือก —" outlined dense hide-details="auto" />
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="field-label">
                                ชั้นศาล
                                <v-tooltip top max-width="260">
                                    <template #activator="{ on, attrs }">
                                        <span class="info-tag" v-bind="attrs" v-on="on">i</span>
                                    </template>
                                    <span>แนะนำเพิ่ม: ศาลชั้นต้น/อุทธรณ์/ฎีกา — มีผลต่อค่าธรรมเนียมและขอบเขตงาน</span>
                                </v-tooltip>

                            </div>
                            <v-select v-model="form.courtLevel" :items="courtLevelList" item-text="name" item-value="id"
                                outlined dense hide-details="auto" placeholder="— เลือก —" />
                        </v-col>



                        <v-col cols="12" md="4">
                            <div class="field-label">
                                ทุนทรัพย์
                                <v-tooltip top max-width="260">
                                    <template #activator="{ on, attrs }">
                                        <span class="info-tag" v-bind="attrs" v-on="on">i</span>
                                    </template>
                                    <span>แนะนำเพิ่ม: จำนวนเงินที่พิพาท ใช้ประเมินค่าวิชาชีพและความเสี่ยง</span>
                                </v-tooltip>

                            </div>
                            <v-text-field v-model="form.claimAmount" placeholder="฿ (ถ้ามี)" type="number" outlined
                                dense hide-details="auto" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="field-label">
                                ทนายผู้รับผิดชอบ <span class="req">*</span>
                                <v-tooltip top max-width="260">
                                    <template #activator="{ on, attrs }">
                                        <span class="info-tag" v-bind="attrs" v-on="on">i</span>
                                    </template>
                                    <span>แนะนำเพิ่ม: ผูกกับ workload และใช้กรอง Overview ตามทนาย</span>
                                </v-tooltip>
                            </div>

                            <!-- ทนายหลัก + ปุ่มเปิด/ปิดช่องทนายร่วม -->
                            <div class="d-flex align-center" style="gap: 8px;">
                                <v-select v-model="form.lawyerId" :items="lawyerList" item-text="name" item-value="id"
                                    placeholder="— เลือก —" :rules="[rules.required]" outlined dense hide-details="auto"
                                    style="flex: 1;" @change="onMainLawyerChange" />
                                <v-btn v-if="!showCoLawyer" class="add-btn" outlined :disabled="!form.lawyerId"
                                    @click="showCoLawyer = true" title="เพิ่มทนายร่วม">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                                <v-btn v-else class="add-btn remove" outlined @click="closeCoLawyer" title="ลบทนายร่วม">
                                    <v-icon>mdi-minus</v-icon>
                                </v-btn>
                            </div>

                            <!-- ทนายร่วม: แสดงเมื่อกด + แล้วเท่านั้น -->
                            <v-autocomplete v-if="showCoLawyer" v-model="additionalLawyers" :items="coLawyerList"
                                item-text="name" item-value="id" placeholder="— เลือกทนายร่วม (เลือกได้หลายคน) —"
                                multiple chips deletable-chips small-chips outlined dense hide-details="auto"
                                class="mt-2" />
                        </v-col>
                    </v-row>
                </div>

                <!-- ============ SECTION B: คู่ความ ============ -->
                <div class="sec">
                    <div class="sec-label">B · คู่ความ (Parties)</div>
                    <v-row>
                        <v-col cols="12" md="6">
                            <div class="field-label">
                                โจทก์ <span class="hint">(บรรทัดละ 1 ชื่อ)</span>
                            </div>
                            <v-textarea v-model="form.plaintiffs" :placeholder="'ชื่อโจทก์ที่ 1\nชื่อโจทก์ที่ 2'"
                                rows="3" outlined dense hide-details="auto" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="field-label">
                                จำเลย <span class="hint">(บรรทัดละ 1 ชื่อ)</span>
                            </div>
                            <v-textarea v-model="form.defendants" :placeholder="'ชื่อจำเลยที่ 1\nชื่อจำเลยที่ 2'"
                                rows="3" outlined dense hide-details="auto" />
                        </v-col>
                    </v-row>
                </div>

                <!-- ============ SECTION C: วันนัด (repeatable) ============ -->
                <div class="sec">
                    <div class="sec-label">C · วันนัดพิจารณาคดี / วันนัดสืบพยาน</div>

                    <div v-for="(hearing, index) in form.hearings" :key="index" class="hearing-row">
                        <v-row>
                            <v-col cols="12" md="5">
                                <div class="field-label" v-if="index === 0">หัวข้อนัด</div>
                                <v-text-field v-model="hearing.topic" placeholder="เช่น สืบพยานโจทก์" outlined dense
                                    hide-details="auto" />
                            </v-col>
                            <v-col cols="6" md="3">
                                <div class="field-label" v-if="index === 0">วันนัด</div>
                                <v-menu v-model="hearing.menu" :close-on-content-click="false"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template #activator="{ on, attrs }">
                                        <v-text-field :value="formatDate(hearing.date)" placeholder="dd/mm/yyyy"
                                            readonly outlined dense hide-details="auto" v-bind="attrs" v-on="on"
                                            append-icon="mdi-calendar" />
                                    </template>
                                    <v-date-picker v-model="hearing.date" no-title locale="th"
                                        @input="hearing.menu = false" />
                                </v-menu>
                            </v-col>
                            <v-col cols="6" md="3">
                                <div class="field-label" v-if="index === 0">เวลานัด</div>
                                <v-text-field v-model="hearing.time" type="time" outlined dense hide-details="auto"
                                    @click="openTimePicker" />
                            </v-col>
                            <v-col cols="12" md="1" class="d-flex align-end" style="gap: 4px;">
                                <!-- ปุ่มลบ: แสดงเฉพาะเมื่อมีมากกว่า 1 แถว -->
                                <v-btn v-if="form.hearings.length > 1" class="add-btn remove" outlined
                                    @click="removeHearing(index)" title="ลบนัด">
                                    <v-icon>mdi-minus</v-icon>
                                </v-btn>
                                <!-- ปุ่มเพิ่ม: เฉพาะแถวสุดท้าย -->
                                <v-btn v-if="index === form.hearings.length - 1" class="add-btn" outlined
                                    @click="addHearing" title="เพิ่มนัด">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-col>

                        </v-row>
                    </div>

                    <!-- <div class="note-inline">
                        ออกแบบเป็นรายการนัดแบบเพิ่มได้หลายรายการ (repeatable) — ระบบจะนำ
                        "นัดที่ใกล้ที่สุด" ไปแสดงในคอลัมน์ <b>นัดถัดไป</b> ของหน้า Overview อัตโนมัติ
                    </div> -->
                </div>

                <!-- ============ SECTION D: เอกสาร/หมายเหตุ ============ -->
                <div class="sec">
                    <div class="sec-label">D · เอกสารแนบ &amp; หมายเหตุ</div>

                    <div class="field-label">
                        Upload File <span class="hint danger">(รองรับ .pdf เท่านั้น)</span>
                    </div>
                    <div class="upload-box">
                        <v-btn class="upload-btn" depressed @click="$refs.fileInput.$refs.input.click()"
                            v-if="nonCloseStatus">
                            UPLOAD FILE
                        </v-btn>
                        <v-file-input ref="fileInput" v-model="pendingFiles" accept="application/pdf" multiple
                            class="d-none" hide-details @change="onFilesSelected" />

                        <!-- ไม่มีไฟล์: แสดง hint -->
                        <span class="hint pt-2" v-if="form.files.length === 0">
                            ไม่บังคับ — แนบเฉพาะที่จำเป็น (เช่น คำพิพากษา) เพื่อให้ระบบเบา
                        </span>

                        <!-- มีไฟล์: แสดงรายการข้างปุ่ม -->
                        <div v-else class="file-list pt-2">
                            <div v-for="(f, index) in form.files" :key="index" class="file-item">
                                <v-icon small class="mr-1">mdi-file-pdf-box</v-icon>
                                <a href="#" class="file-name" @click.prevent="previewFile(f)">{{ f.name }}</a>
                                <v-btn icon x-small class="ml-1" @click="removeFile(index)" title="ลบ">
                                    <v-icon small color="error">mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </div>

                    <div class="field-label mt-4">หมายเหตุ</div>
                    <v-textarea v-model="form.remark" placeholder="บันทึกความคืบหน้า / งานที่ทำเบื้องต้น" rows="3"
                        outlined dense hide-details="auto" />

                    <div class="field-label mt-4">สถานะคดี</div>
                    <v-select v-model="form.caseStatus" :items="statuslist" item-text="descriptions"
                        item-value="module_id" outlined dense hide-details="auto" placeholder="— เลือก —"
                        @change="sendToStatus" />

                    <!-- <div class="note-inline mt-2">
                        เปลี่ยนเป็น dropdown (เดิมเป็น free text) เพื่อให้ฟิลเตอร์ใน Overview
                        ทำงานได้และรายงานแม่นยำ
                    </div> -->
                </div>

                <!-- ============ SECTION E: การเงิน / INVOICE ============ -->
                <InvoiceSectionPanel :sales-order-id.sync="form.salesOrderId" :customer-name="form.customerName"
                    :price="form.price" :currency="form.currency" :sales-order-list="salesOrderList"
                    :invoice-list="invoiceList" :invoice-status-list="invoiceStatusList"
                    section-label="E · การเงิน & สถานะ Invoice" :readonly="!nonCloseStatus" @select-so="onSelectSO"
                    @preview="previewInvoice" />




            </v-card>
            <v-card-text v-if="tabselect == 1">
                <TimeLineOperations :showaddItem="form" :statuslist="statuslist" :reportlist="reportlist"
                    :modeOperations="modeOperations" :timelineStatus="timelineStatus" :status_note="status_note"
                    :visible_check="visible_check" :module_name="module_name" :timeline_case_id="timeline_case_id"
                    @timelineStatus="timelineStatus = $event" :showReportInv="false"
                    @requestStatus="handleRequestStatus" @update:status_note="status_note = $event"
                    @update:visible_check="visible_check = $event" />
            </v-card-text>
            <div class="footer-actions" v-if="nonCloseStatus">
                <v-btn color="primary" class="px-8 navy-btn" depressed @click="onSave('Save')">
                    SAVE
                </v-btn>
                <v-btn outlined class="px-8" @click="onCancel">CANCEL</v-btn>
                <v-btn :class="['px-8', { 'is-locked': requestPaymentDisabled }]" color="teal" dark depressed
                    title="เปิดใช้เมื่อมี Price + Sales Order ID แล้วเท่านั้น"
                    @click="requestPaymentDisabled ? null : onSave('Payment')">
                    Request Payment
                </v-btn>
            </div>
        </v-form>
        <v-dialog v-model="dialogDelete" max-width="600px">
            <v-card class="pa-10" style="border: 5px solid #e5e7eb;">
                <v-card-title style="padding-bottom: 20px;">
                    <v-row justify="center">
                        <span class="text-h4 font-weight-bold">Timeline Update Required</span>
                    </v-row>
                </v-card-title>
                <br />
                <v-card-subtitle>
                    <v-row justify="center" class="text-center">
                        <span class="black--text text-body-1">
                            Before saving this case, please update the internal timeline so the team can see the latest
                            work
                            status.
                        </span>
                    </v-row>
                </v-card-subtitle>
                <v-card-actions style="padding-top: 20px">
                    <v-spacer></v-spacer>
                    <v-btn depressed width="170" class="mr-3 " color="#0A7EA5" @click="deleteItemConfirm"
                        style="border-radius: 20px; color: white; text-transform: none;">
                        Update Timeline
                    </v-btn>
                    <v-btn depressed width="170" @click="closeDelete" color="red"
                        style="border-radius: 20px; color: white; text-transform: none;">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
            <!-- <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this item?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card> -->
        </v-dialog>
    </div>
</template>

<script>
import api from "@/services/api";
import { server, litigationDocketCaseUrl } from "@/services/constants";
import TimeLineOperations from "../timeline/TimeLineOperations.vue";
import InvoiceSectionPanel from "../payment-invoice/InvoiceSectionPanel.vue";
import Swal from 'sweetalert2'
import PDFCaseProgress from "@/utils/pdfClientTimeLine";
const moment = require("moment-timezone");
export default {
    name: "CaseDocket",
    data() {
        return {
            quotationscheckstatus: '',
            statusCloseEditMode: false,
            invoiceList: [],
            // requestPaymentDisabled: true,
            invoiceMenu: false,
            invoiceMenuPay: false,
            formValid: false,
            form: {
                internalCaseNo: "####",
                blackNo: "",
                clientId: null,
                redNo: "",
                charge: "",
                court: null,
                department: null,
                caseType: null,
                courtLevel: "ศาลชั้นต้น",
                lawyerId: null,
                claimAmount: "",
                plaintiffs: "",
                defendants: "",
                hearings: [{ id: 0, topic: "", date: "", time: "", menu: false }],
                remark: "",
                caseStatus: 0,
                customerName: "",
                currency: "",
                salesOrderId: "",
                price: "",
                invoiceStatus: "",
                invoiceNo: "",
                invoiceDate: "",
                dueDate: "",
                files: [],
            },
            deletedHearings: [],
            pendingFiles: [],
            additionalLawyers: [],
            originalAdditionalLawyers: [],
            showCoLawyer: false,
            clientList: [
                // { id: 1, name: "บจก. เอ็ม-ไวบ์" },
                // { id: 2, name: "นางสาวอรอนงค์" },
                // { id: 3, name: "บมจ. ไทยเทค" },
            ],
            courtList: [
                // "ศาลแพ่ง", "ศาลอาญา", "ศาลแรงงาน", "ศาลปกครอง"
            ],
            departmentList: [
                // "แผนกคดีผู้บริโภค", "แผนกคดีทรัพย์สินทางปัญญา"
            ],
            caseTypeList: [
                // "แพ่ง", "อาญา", "ล้มละลาย", "ปกครอง"
            ],
            courtLevelList: [
                // "ศาลชั้นต้น", "ศาลอุทธรณ์", "ศาลฎีกา"
            ],

            lawyerList: [
                // { id: 1, name: "ทนายสมศักดิ์" },
                // { id: 2, name: "ทนายปรียา" },
            ],
            salesOrderList: [],
            invoiceStatusList: ["Draft", "Requested", "Invoiced", "Paid"],

            rules: {
                required: (v) => !!v || "จำเป็นต้องกรอก",
            },
            deletedFiles: [],
            //timeline 
            timelineStatus: 0,
            status_note: "",
            visible_check: false,
            dialogDelete: false,
            timeline_case_id: 0,
            module_name: "Dispute Resolution",
            modeOperations: "",
            tabselect: 0,
            reportlist: [],
            statuslist: [
                // "รับเรื่อง",
                // "ยื่นฟ้อง",
                // "สืบพยาน",
                // "รอคำพิพากษา",
                // "อุทธรณ์/ฎีกา",
                // "ปิดคดี",
            ],

        };
    },
    components: {
        TimeLineOperations,
        InvoiceSectionPanel
    },
    computed: {
        nonCloseStatus() {
            return this.modeOperations === "Edit" ? !this.statusCloseEditMode : true;
        },
        requestPaymentDisabled() {
            const price = Number(this.form.price);
            const salesOrderId = Number(this.form.salesOrderId);
            const customerID = Number(this.form.clientId);

            const isPriceValid = !isNaN(price) && price > 0;
            const isSalesOrderIdValid = !isNaN(salesOrderId) && salesOrderId > 0;
            const isCustomerIdValid = !isNaN(customerID) && customerID > 0;

            return !(isPriceValid && isSalesOrderIdValid && isCustomerIdValid);
        },
        coLawyerList() {
            // ตัดทนายหลักออกจากตัวเลือกทนายร่วม
            return this.lawyerList.filter(l => l.id !== this.form.lawyerId);
        },
    },
    async beforeCreate() {
        this.$store.state.navMenu = true;
    },
    async mounted() {
        try {
            await api.checkVersion();

            this.userId = localStorage.getItem(server.USER_ID);
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

            // ----------------- Check Authorize ID ---------------------------
            if (this.authorize_id == null || this.authorize_id == 0) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Authorize Failed!!!",
                    "Please Logout And Login Again!!!",
                    "text-h5 red--text text-center"
                );
                this.$router.back();
                return;
            }

            // ----------------- Resolve Current Route Path -------------------
            const parser = document.createElement("a");
            parser.href = window.location;
            const routerPath = parser.pathname.split("/")[1];

            // ----------------- Fetch Authorization --------------------------
            const resAuth = await api.getAuthorize(this.userId, routerPath);
            const permission = resAuth.data[0];

            if (!permission) {
                this.$router.back();
                return;
            }

            this.authorize_view = permission.smd_view >= 1;
            this.authorize_add = permission.smd_add >= 1;
            this.authorize_edit = permission.smd_edit >= 1;
            this.authorize_del = permission.smd_del >= 1;

            if (!this.authorize_view) {
                this.$router.back();
                return;
            }

            // ----------------- Check Login Status ---------------------------
            if (this.userId && api.isLoggedIn()) {
                // already logged in
            } else {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
                return;
            }

            await this.loaddataLitigationCourt()
            await this.loaddataLitigationCourtLevel()
            await this.loaddataLitigationCourtCasetype()
            await this.loaddataLitigationCourtDepartment()
            await this.loaddataClientList()
            await this.loaddataLawyerList()
            await this.loaddataSalesOrder()
            await this.loaddataLitigationCourtStatus()
            // ----------------- Resolve Mode (New / Edit) --------------------
            const id = this.$route.params.id;
            if (id === "new") {
                // โหมดสร้างใหม่
                this.modeOperations = "New";
                // this.caseId = null;
                // ฟอร์มว่างไว้ตามค่า default ใน data() อยู่แล้ว
                // await this.loadDataDocrunningNew()
            } else {
                // โหมดแก้ไข — id เป็นตัวเลข
                this.modeOperations = "Edit";
                // this.caseId = id;
                this.timeline_case_id = Number(id);
                await this.loadData(id);
                await this.loadFile(id);
                await this.loadAdditionalLawyers(id);
                await this.loadHearings(id);
                await this.loadDataInvoice(id);
            }

        } catch (error) {
            console.error("mounted() error:", error);
            this.$store.state.isLogged = false;
            this.$router.push("/login");
        } finally {
            this.$hideLoader();
        }
    },
    beforeRouteUpdate(to, from, next) {
        // route เปลี่ยน id แต่ component ตัวเดิม -> สั่งรีโหลดหน้าทั้งหมด
        next();
        location.reload();
    },
    methods: {

        async loaddataLitigationCourt() {
            try {
                const res = await api.dispute_resolution_getall_court();
                this.courtList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourt error:", error);
            }
        },

        async loaddataLitigationCourtLevel() {
            try {
                const res = await api.dispute_resolution_getall_courtlevel();
                this.courtLevelList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourtLevel error:", error);
            }
        },
        async loaddataLitigationCourtCasetype() {
            try {
                const res = await api.dispute_resolution_getall_courttype();
                this.caseTypeList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourtCasetype error:", error);
            }
        },
        async loaddataLitigationCourtDepartment() {
            try {
                const res = await api.dispute_resolution_getall_courtdepartment();
                this.departmentList = res.data || [];
            } catch (error) {
                console.error("loaddataLitigationCourtDepartment error:", error);
            }
        },
        async loaddataClientList() {
            try {
                const res = await api.dispute_resolution_get_clienList(Number(localStorage.getItem(server.COMPANYID)));
                this.clientList = res.data || [];
            } catch (error) {
                console.error("loaddataClientList error:", error);
            }
        },
        async loaddataLawyerList() {
            try {
                const res = await api.dispute_resolution_get_lawyerList(Number(localStorage.getItem(server.COMPANYID)));
                this.lawyerList = res.data.data || [];
            } catch (error) {
                console.error("loaddataLawyerList error:", error);
            }
        },
        async loaddataSalesOrder() {
            try {
                const res = await api.dispute_resolution_get_quotationsList(Number(localStorage.getItem(server.COMPANYID)));
                this.salesOrderList = res.data.data || [];

            } catch (error) {
                console.error("loaddataSalesOrder error:", error);
            }
        },
        async loadDataDocrunningNew() {
            try {
                const res = await api.dispute_resolution_get_docruningDocket(Number(localStorage.getItem(server.COMPANYID)));
                // เซ็ตเลขรันที่ได้ลงช่อง "รหัสคดีภายใน"
                this.form.internalCaseNo = res.data.data || "";
            } catch (error) {
                console.error("loadDataDocrunningNew error:", error);
            }
        },
        async loadData(id) {
            try {
                const res = await api.dispute_resolution_getbyid_docket(Number(id));
                const d = res.data[0];

                this.form.internalCaseNo = d.internal_case_no || "";
                this.form.blackNo = d.black_no || "";
                this.form.clientId = d.client_id || null;
                this.form.redNo = d.red_no || "";
                this.form.charge = d.charge || "";
                this.form.court = d.court ?? null;
                this.form.department = d.department ?? null;
                this.form.caseType = d.case_type ?? null;
                this.form.courtLevel = d.court_level ?? "ศาลชั้นต้น";
                this.form.lawyerId = d.lawyer_id || null;
                this.form.claimAmount = d.claim_amount || "";
                this.form.plaintiffs = d.plaintiffs || "";
                this.form.defendants = d.defendants || "";
                this.form.remark = d.remark || "";
                this.form.caseStatus = d.case_status != null ? Number(d.case_status) : 0;

                const selectedItem = this.statuslist.find(
                    item => Number(item.module_id) === Number(this.form.caseStatus)
                );
                if (selectedItem) {
                    this.statusCloseEditMode = selectedItem.status === "ปิดคดี";
                    this.timelineStatus = Number(selectedItem.timeline_status_id);
                } else {
                    this.statusCloseEditMode = false;
                    this.timelineStatus = 0;
                }

                this.form.salesOrderId = d.sales_order_id || "";
                // ค้น object เองตอนโหลดข้อมูลเดิม เพราะไม่ได้ผ่าน event จาก component
                const so = this.salesOrderList.find(
                    item => Number(item.quotation_id) === Number(this.form.salesOrderId)
                );
                this.onSelectSO(so || null);
            } catch (error) {
                console.error("loadData error:", error);
            }
        },
        async loadAdditionalLawyers(id) {
            try {
                const res = await api.dispute_resolution_getbyid_additional_lawyers(id)
                this.additionalLawyers = res.data.map(item => item.user_id);
                this.originalAdditionalLawyers = [...this.additionalLawyers]; // เก็บค่าเดิม
                if (this.additionalLawyers.length > 0) {
                    this.showCoLawyer = true;
                }
            } catch (error) {
                console.error("loadAdditionalLawyers error:", error);
            }
        },
        async loadHearings(id) {
            try {
                const res = await api.dispute_resolution_getbyid_hearings(id)
                this.form.hearings = (res.data || []).map(item => ({
                    id: item.id,
                    topic: item.topic || "",
                    date: item.date || "",
                    time: item.time ? item.time.slice(0, 5) : "",
                    menu: false,
                }));

            } catch (error) {
                console.error("loadHearings error:", error);
            }
        },
        async loadDataInvoice(id) {
            try {
                var dataserach = {
                    module_name: 'Litigations',
                    module_id: id,
                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                }
                const res = await api.dispute_resolution_get_invoiceList({
                    params: dataserach
                })
                this.invoiceList = res.data.data || [];
            } catch (error) {
                console.error("loadDataInvoice error:", error);
            }
        },
        async loadFile(id) {
            try {
                const res = await api.dispute_resolution_load_file(id, Number(localStorage.getItem(server.COMPANYID)));

                this.form.files = (res.data || []).map(item => ({
                    id: item.id,
                    name: item.file_name,
                    url: `${litigationDocketCaseUrl}/${item.module_id}/${item.file_name}`,
                    raw: null,        // ไฟล์เดิมจาก server ไม่มี raw
                    isExisting: true, // ธงบอกว่าเป็นไฟล์เก่า (เผื่อ logic ตอน save/delete)
                }));
            } catch (error) {
                console.error("loadFile error:", error);
            }
        },
        //timelinestatus
        closeDelete() {
            this.dialogDelete = false;
        },
        deleteItemConfirm() {
            this.tabselect = 1;
            this.dialogDelete = false;
        },

        handleRequestStatus(value) {
            this.form.caseStatus = Number(value)
        },
        sendToStatus(value) {
            const selectedItem = this.statuslist.find(
                item => item.module_id === value
            )
            this.timelineStatus = Number(selectedItem.timeline_status_id)
        },
        previewInvoice(item) {
            const routeData = this.$router.resolve(
                `/edit-invoice/${item.inv_id_preview}/inv_h/edit`
            );
            window.open(routeData.href, '_blank');
        },
        async loaddataLitigationCourtStatus() {
            const result = await api.getClientTimelineStatusCongFigByModule("Dispute Resolution");

            this.statuslist = (result.data || []).map(item => ({
                ...item,
                module_id: Number(item.module_id)
            }));

        },
        //end

        openTimePicker(event) {
            const input = event.target.closest('.v-text-field')?.querySelector('input[type="time"]');
            if (input && typeof input.showPicker === 'function') {
                input.showPicker();
            }
        },
        formatDate(date) {
            if (!date) return "";
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        onMainLawyerChange() {
            if (!this.form.lawyerId) {
                // ถ้าล้างทนายหลัก ปิดช่องทนายร่วม + เคลียร์
                this.showCoLawyer = false;
                this.additionalLawyers = [];
                return;
            }
            // ถ้าเลือกทนายหลักชนกับทนายร่วม ให้ดึงออก
            this.additionalLawyers = this.additionalLawyers.filter(
                id => id !== this.form.lawyerId
            );
        },
        closeCoLawyer() {
            this.showCoLawyer = false;
            this.additionalLawyers = [];
        },
        addHearing() {
            this.form.hearings.push({ id: 0, topic: "", date: "", time: "", menu: false });
        },
        removeHearing(index) {
            const h = this.form.hearings[index];
            if (h.id && h.id !== 0) {
                this.deletedHearings.push(h.id);
            }
            this.form.hearings.splice(index, 1);
            // กันลิสต์ว่าง — ให้มีแถวเปล่าไว้กรอกเสมอ
            if (this.form.hearings.length === 0) {
                this.form.hearings.push({ id: 0, topic: "", date: "", time: "", menu: false });
            }
        },
        onFilesSelected(files) {
            if (!files || !files.length) return;
            const list = Array.isArray(files) ? files : [files];

            list.forEach(file => {
                if (file.type !== 'application/pdf') return;   // ✅ เช็คในนี้ ทีละไฟล์

                const uniqueName = this.getUniqueName(file.name);
                const finalFile = uniqueName === file.name
                    ? file
                    : new File([file], uniqueName, { type: file.type });

                this.form.files.push({
                    name: uniqueName,
                    raw: finalFile,
                    url: URL.createObjectURL(finalFile),
                });
            });

            this.pendingFiles = [];
        },

        getUniqueName(name) {
            const existing = this.form.files.map(f => f.name);
            if (!existing.includes(name)) return name;

            // แยกชื่อกับนามสกุล
            const dot = name.lastIndexOf('.');
            const base = dot === -1 ? name : name.slice(0, dot);
            const ext = dot === -1 ? '' : name.slice(dot);

            let i = 1;
            let candidate = `${base}_${i}${ext}`;
            while (existing.includes(candidate)) {
                i++;
                candidate = `${base}_${i}${ext}`;
            }
            return candidate;
        },

        previewFile(f) {
            // เปิด PDF ในแท็บใหม่
            window.open(f.url, '_blank');
        },

        removeFile(index) {
            const f = this.form.files[index];

            if (f.isExisting) {
                // ไฟล์เก่าจาก server → จำไว้เพื่อไปลบตอน save
                this.deletedFiles.push({
                    id: f.id,
                    name: f.name,
                });
            } else if (f.url) {
                // ไฟล์ใหม่ → คืน memory ของ object URL
                URL.revokeObjectURL(f.url);
            }

            this.form.files.splice(index, 1);
        },
        onSelectSO(so) {
            // component ส่ง object ของ quotation ที่เลือกมาให้แล้ว (หรือ null ถ้าเคลียร์ค่า)
            if (!so) {
                this.form.price = "";
                this.form.customerName = "";
                this.form.currency = "";
                this.quotationscheckstatus = "";
                return;
            }
            this.quotationscheckstatus = so.status;
            this.form.price = Number(so.subtotal);
            this.form.customerName = so.customer_name || "";
            this.form.currency = so.currency || "";
        },

        async onSave(mode) {

            if (this.$refs.form.validate()) {


                // ✅ ตรวจว่าลูกค้าใน Quotation ตรงกับลูกค้าที่เลือกในคดีนี้
                // กันเคสผูก Quotation ของลูกค้าคนอื่นเข้ากับคดี ทำให้วางบิลผิดคน
                if (this.form.salesOrderId) {
                    const selectedSO = this.salesOrderList.find(
                        item => Number(item.quotation_id) === Number(this.form.salesOrderId)
                    );

                    if (!selectedSO) {
                        Swal.fire({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: "ไม่พบใบเสนอราคาที่เลือก กรุณาเลือกใหม่อีกครั้ง",
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                        });
                        return;
                    }

                    if (Number(selectedSO.client_id) !== Number(this.form.clientId)) {
                        Swal.fire({
                            icon: "warning",
                            title: "ข้อมูลลูกค้าไม่ตรงกัน",
                            html: `ใบเสนอราคา <b>${selectedSO.doc_no}</b> เป็นของลูกค้า <b>${selectedSO.customer_name || "-"}</b><br/>
                           ซึ่งไม่ตรงกับลูกค้าที่เลือกในคดีนี้<br/>
                           กรุณาตรวจสอบและเลือกใหม่ให้ถูกต้อง`,
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                        });
                        return;
                    }
                }
                if (this.timelineStatus == 0 || this.status_note.trim() == "") {
                    this.dialogDelete = true;
                    return;
                }
                // helper: แปลง string ว่าง / undefined ให้เป็น null
                const toNull = (v) => (v === "" || v === undefined || v === null ? null : v);
                // helper: แปลงเป็นตัวเลข ถ้าว่างเป็น null
                const toNumber = (v) => {
                    if (v === "" || v === undefined || v === null) return null;
                    const n = Number(v);
                    return isNaN(n) ? null : n;
                };

                const resdoc = await api.dispute_resolution_get_docruningDocket(Number(localStorage.getItem(server.COMPANYID)));
                // เซ็ตเลขรันที่ได้ลงช่อง "รหัสคดีภายใน"
                this.form.internalCaseNo = resdoc.data.data || "";

                var datalist = {
                    internal_case_no: this.form.internalCaseNo,           // required - ไม่ดัก
                    black_no: toNull(this.form.blackNo),
                    client_id: toNumber(this.form.clientId),              // required (bigint)
                    red_no: toNull(this.form.redNo),
                    charge: toNull(this.form.charge),
                    court: toNumber(this.form.court),                     // int
                    department: toNumber(this.form.department),           // int
                    case_type: toNumber(this.form.caseType),              // int
                    court_level: toNumber(this.form.courtLevel),          // int *
                    claim_amount: toNumber(this.form.claimAmount),        // numeric
                    lawyer_id: toNumber(this.form.lawyerId),              // required (bigint)
                    plaintiffs: toNull(this.form.plaintiffs),
                    defendants: toNull(this.form.defendants),
                    remark: toNull(this.form.remark),
                    case_status: toNumber(this.form.caseStatus),          // bigint
                    sales_order_id: toNumber(this.form.salesOrderId),     // bigint
                    user_update: Number(localStorage.getItem(server.USER_ID)),
                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                };
                try {
                    await this.$showLoader()
                    var res = [];
                    if (this.modeOperations == "New") {
                        datalist.user_create = Number(localStorage.getItem(server.USER_ID));
                        res = await api.dispute_resolution_add_docket(datalist)
                        var main_id = res.data.id;

                        //add timeline
                        var dataadd_timeline = {

                            timeline_status_id: Number(this.timelineStatus),
                            case_id: Number(main_id),
                            module_name: "Dispute Resolution",
                            case_woker: Number(localStorage.getItem(server.USER_ID)),
                            status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
                            status_note: this.status_note.trim(),
                            visibility: this.visible_check,
                        }
                        await api.creategetClientTimelineHistory(dataadd_timeline)
                        try {
                            const caseDetailResult = await api.getgetTimelineDataDetail({
                                params: { module_name: this.module_name, case_id: Number(main_id) },
                            });
                            const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };

                            const visibilityResult = await api.getgetClientTimelineHistoryShowVisibility({
                                params: { module_name: this.module_name, case_id: Number(main_id) },
                            });
                            const timelineData = visibilityResult.data || [];

                            caseInfo.status = timelineData[0]?.status || '';
                            caseInfo.lastUpdated = timelineData[0]?.status_time || '';

                            const latestUpdate = {
                                message: timelineData[0]?.status_note || '',
                                date: timelineData[0]?.status_time || '',
                            };

                            await PDFCaseProgress.createToPDF(
                                {
                                    caseInfo,
                                    latestUpdate,
                                    timelineData,
                                    caseId: Number(main_id),
                                    moduleName: this.module_name,
                                },
                                { open: false }
                            );
                        } catch (pdfError) {
                            console.error("PDF generation/upload failed:", pdfError);
                            // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึกคดี/ทนายร่วม/วันนัด/ไฟล์แนบ
                        }
                        //end add timeline 

                        if (this.additionalLawyers.length > 0) {
                            for (const [index, item] of this.additionalLawyers.entries()) {
                                var dataAdditionalLawyers = {
                                    litigation_docket_id: main_id,
                                    user_id: item,
                                    user_create: Number(localStorage.getItem(server.USER_ID)),
                                    user_update: Number(localStorage.getItem(server.USER_ID))
                                }
                                await api.dispute_resolution_add_additional_lawyers(dataAdditionalLawyers)
                            }

                        }

                        for (const [index, item] of this.form.hearings.entries()) {
                            if (item.date != "" && item.time != "" && item.topic != "") {
                                var dataaddhearings = {
                                    litigation_docket_id: Number(main_id),
                                    topic: item.topic,
                                    date: item.date,
                                    time: item.time,
                                    user_create: Number(localStorage.getItem(server.USER_ID)),
                                    user_update: Number(localStorage.getItem(server.USER_ID))
                                };



                                await api.dispute_resolution_add_hearings(dataaddhearings);
                            }
                        }
                        if (this.form.files.length > 0) {
                            for (const [index, item] of this.form.files.entries()) {
                                let formData = new FormData();
                                formData.append("file", item.raw);
                                formData.append("id", Number(main_id));
                                formData.append("user_id", Number(localStorage.getItem(server.USER_ID)));
                                formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));
                                await api.dispute_resolution_upload_file(formData)
                            }
                        }

                    } else {
                        await api.dispute_resolution_update_docket(Number(this.$route.params.id), datalist)
                        //add timeline
                        var dataadd_timeline = {

                            timeline_status_id: Number(this.timelineStatus),
                            case_id: Number(this.$route.params.id),
                            module_name: "Dispute Resolution",
                            case_woker: Number(localStorage.getItem(server.USER_ID)),
                            status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
                            status_note: this.status_note.trim(),
                            visibility: this.visible_check,
                        }
                        await api.creategetClientTimelineHistory(dataadd_timeline)

                        try {
                            const caseDetailResultEdit = await api.getgetTimelineDataDetail({
                                params: { module_name: this.module_name, case_id: Number(this.$route.params.id) },
                            });
                            const caseInfoEdit = { ...(caseDetailResultEdit.data?.[0] || {}) };

                            const visibilityResultEdit = await api.getgetClientTimelineHistoryShowVisibility({
                                params: { module_name: this.module_name, case_id: Number(this.$route.params.id) },
                            });
                            const timelineDataEdit = visibilityResultEdit.data || [];

                            caseInfoEdit.status = timelineDataEdit[0]?.status || '';
                            caseInfoEdit.lastUpdated = timelineDataEdit[0]?.status_time || '';

                            const latestUpdateEdit = {
                                message: timelineDataEdit[0]?.status_note || '',
                                date: timelineDataEdit[0]?.status_time || '',
                            };

                            await PDFCaseProgress.createToPDF(
                                {
                                    caseInfo: caseInfoEdit,
                                    latestUpdate: latestUpdateEdit,
                                    timelineData: timelineDataEdit,
                                    caseId: Number(this.$route.params.id),
                                    moduleName: this.module_name,
                                },
                                { open: false }
                            );
                        } catch (pdfError) {
                            console.error("PDF generation/upload failed:", pdfError);
                            // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึกคดี/ทนายร่วม/วันนัด/ไฟล์แนบ
                        }
                        //end add timeline 

                        //edit ทนายร่วม
                        const oldIds = this.originalAdditionalLawyers;
                        const newIds = this.additionalLawyers;

                        // ตัวที่เพิ่มใหม่ = อยู่ใน new แต่ไม่อยู่ใน old
                        const added = newIds.filter(id => !oldIds.includes(id));

                        // ตัวที่ถูกลบ = อยู่ใน old แต่ไม่อยู่ใน new
                        const removed = oldIds.filter(id => !newIds.includes(id));

                        // ตัวที่ไม่เปลี่ยน (ถ้าอยากรู้) = อยู่ทั้งสองฝั่ง
                        // const unchanged = newIds.filter(id => oldIds.includes(id));


                        // insert ตัวที่เพิ่ม
                        for (const item of added) {
                            await api.dispute_resolution_add_additional_lawyers({
                                litigation_docket_id: Number(this.$route.params.id),
                                user_id: item,
                                user_create: Number(localStorage.getItem(server.USER_ID)),
                                user_update: Number(localStorage.getItem(server.USER_ID))
                            });
                        }

                        // delete ตัวที่ถูกเอาออก
                        for (const item of removed) {
                            await api.dispute_resolution_delete_additional_lawyer_by_user(
                                Number(this.$route.params.id),
                                item
                            );
                        }

                        //  วันนัดพิจารณาคดี / วันนัดสืบพยาน
                        // ----- ลบตัวที่ผู้ใช้กดลบ (ของเดิม) -----

                        for (const hid of this.deletedHearings) {
                            await api.dispute_resolution_delete_hearings(hid);
                        }

                        for (const item of this.form.hearings) {
                            // ข้ามแถวที่กรอกไม่ครบ
                            if (item.date == "" || item.time == "" || item.topic == "") continue;

                            if (item.id && item.id !== 0) {
                                // ----- ของเดิม → update -----
                                await api.dispute_resolution_update_hearings(item.id, {
                                    topic: item.topic,
                                    date: item.date,
                                    time: item.time,
                                    user_update: Number(localStorage.getItem(server.USER_ID)),
                                });
                            } else {
                                // ----- ของใหม่ (id = 0) → insert -----
                                await api.dispute_resolution_add_hearings({
                                    litigation_docket_id: Number(this.$route.params.id),
                                    topic: item.topic,
                                    date: item.date,
                                    time: item.time,
                                    user_create: Number(localStorage.getItem(server.USER_ID)),
                                    user_update: Number(localStorage.getItem(server.USER_ID)),
                                });
                            }
                        }

                        // ----- ลบไฟล์เดิมที่ผู้ใช้กดลบ -----
                        for (const f of this.deletedFiles) {
                            await api.dispute_resolution_delete_file(Number(this.$route.params.id), f.id, f.name);
                        }

                        // ----- อัปโหลดเฉพาะไฟล์ใหม่ (ไฟล์เดิมข้าม) -----
                        for (const item of this.form.files) {
                            if (item.isExisting) continue;   // ไฟล์เดิมจาก server ไม่ต้อง upload ซ้ำ
                            let formData = new FormData();
                            formData.append("file", item.raw);
                            formData.append("id", Number(this.$route.params.id));
                            formData.append("user_id", Number(localStorage.getItem(server.USER_ID)));
                            formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));
                            await api.dispute_resolution_upload_file(formData);
                        }
                    }
                    await this.$hideLoader();
                    await Swal.fire({
                        icon: "success",
                        title: this.modeOperations == "New" ? "เพิ่มสำเร็จ" : "แก้ไขสำเร็จ",
                        text: this.modeOperations == "New"
                            ? "เพิ่มข้อมูลคดีเรียบร้อยแล้ว"
                            : "บันทึกการแก้ไขเรียบร้อยแล้ว",
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true,
                    });
                    try {
                        if (this.quotationscheckstatus == "Submitted") {


                            var dataupdateStatus = {
                                status: "InProgress"
                            }
                            await api.dispute_resolution_update_qutations(Number(this.form.salesOrderId), dataupdateStatus)
                        }
                    } catch (quotationsError) {
                        Swal.fire({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                        });
                        return;
                    }
                    if (mode == "Save") {

                        if (this.modeOperations == "New") {
                            this.$router.push(`/dispute-resolution-docket/${res.data.id}`);
                        } else {
                            this.$router.go(0);
                        }
                    } else {

                        var customer_name_master_show = this.clientList.find(
                            item => item.id === this.form.clientId
                        )?.name

                        var dataPush = {
                            customer_name_master: customer_name_master_show,
                            module_id: 0,
                            quotation_id: toNumber(this.form.salesOrderId),
                        }
                        if (this.modeOperations == "New") {
                            dataPush.module_id = Number(res.data.id);
                        } else {
                            dataPush.module_id = Number(this.$route.params.id);
                        }

                        this.$router.push({
                            path: `/new-free-invoice/0/invoice/D/${this.form.clientId}/Litigations`,
                            query: dataPush,
                        });
                    }
                } catch (error) {

                    Swal.fire({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                }
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'กรุณากรอกข้อมูลให้ครบ',
                    text: 'โปรดกรอกข้อมูล "จำเป็นต้องกรอก" ให้ครบก่อนบันทึก',
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                })
            }
        },
        onCancel() {
            this.$router.push(`/litigation-overview`);
        },
        onRequestPayment() {
            // TODO: ยิง request payment
        },
    },
    beforeDestroy() {
        this.form.files.forEach(f => {
            if (f.raw && f.url) URL.revokeObjectURL(f.url);
        });
    }
};
</script>

<style scoped>
.case-docket {
    max-width: 1180px;
    margin: 0 auto;
    padding: 22px;
    color: #1f2733;
    font-size: 14px;
}

/* header */
.page-head .title {
    font-size: 20px;
    margin: 0 0 4px;
    font-weight: 600;
}

.page-head .sub {
    color: #6b7785;
    margin: 0 0 18px;
}

.docket-panel {
    border-color: #d4d9e0 !important;
    border-radius: 10px;
}

/* section divider */
.sec {
    border-top: 1px solid #d4d9e0;
    margin-top: 22px;
    padding-top: 18px;
}

.sec:first-of-type {
    border-top: none;
    margin-top: 6px;
    padding-top: 0;
}

.sec-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #1b7a99;
    font-weight: 700;
    margin-bottom: 14px;
}

.sec-label .hint {
    color: #6b7785;
    font-weight: 400;
    text-transform: none;
    letter-spacing: 0;
}

/* field labels (above inputs, like wireframe) */
.field-label {
    font-size: 12.5px;
    color: #37424f;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    gap: 6px;
    min-height: 18px;
}

.field-label .hint {
    font-size: 11px;
    color: #6b7785;
}

.field-label .hint.danger {
    color: #c0392b;
}

.field-label .req {
    color: #c0392b;
}

/* info tag (i with tooltip) */
.info-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #c47f00;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    cursor: help;
}

/* NEW badge */
.new-badge {
    margin-left: auto;
    background: #1f8f4e;
    color: #fff;
    font-size: 9px;
    font-weight: 700;
    padding: 1px 6px;
    border-radius: 10px;
    letter-spacing: 0.5px;
}

/* hearing repeatable row */
.hearing-row {
    margin-bottom: 8px;
}

.add-btn {
    min-width: 36px !important;
    width: 36px;
    height: 38px !important;
    padding: 0 !important;
    border: 1px dashed #1b7a99 !important;
    color: #1b7a99 !important;
}

.add-btn.remove {
    border-color: #c0392b !important;
    color: #c0392b !important;
}

/* upload box */
.upload-box {
    border: 1px dashed #d4d9e0;
    border-radius: 8px;
    padding: 14px;
    display: flex;
    align-items: start;
    gap: 12px;
    background: #fafbfc;
}

.upload-btn {
    background: #1b7a99 !important;
    color: #fff !important;
}

.upload-box .hint {
    font-size: 11px;
    color: #6b7785;
}

/* invoice box */
.invoice-box {
    background: #f7fafc;
    border: 1px solid #d8e6f0;
    border-radius: 8px;
    padding: 16px;
}

/* inline note */
.note-inline {
    font-size: 11.5px;
    color: #8a6d00;
    background: #fff8e6;
    border-left: 3px solid #e7c65a;
    padding: 6px 10px;
    border-radius: 4px;
}

/* footer */
.footer-actions {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 26px;
}

.navy-btn {
    background: #0e3a5f !important;
    color: #fff !important;
}

@media (max-width: 600px) {
    .footer-actions {
        flex-direction: column;
    }
}

.file-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.file-item {
    display: flex;
    align-items: center;
    font-size: 13px;
}

.file-name {
    color: #1b7a99;
    text-decoration: underline;
    cursor: pointer;
}

.file-name:hover {
    color: #145d75;
}

.is-locked {
    background-color: #b8e6e2 !important;
    border-color: #b8e6e2 !important;
    color: whitesmoke !important;
    opacity: 1 !important;
    pointer-events: none !important;
    cursor: not-allowed !important;
    box-shadow: none !important;
}
</style>